import ResourceService from "./resource.service";

class ReseourceLogService extends ResourceService {
  static get resource() {
    return "resource-import-log";
  }
}

export default ReseourceLogService;
